import React, { useMemo, useState } from 'react';
import UseBettingItemModal from '@pages/Betting/BettingSetting/UseBettingItemModal';
import MakeItemModal from '@pages/Store/component/MakeItemModal';
import ChangePetModal from '@pages/PhotoCard/PhotoCardDetail/statusContents/PetsModal/ChangePetModal';
import UseQuestCreateItemModal from '@pages/Quest/components/UseQuestCreateItemModal';
import { IstoreItem } from '@typings/store/storeItem.interface';
import { IPhotoCard } from '@typings/photocard/photocard.interface';

export type InventoryModalType =
  | 'bettingDemo'
  | 'questCreate'
  | 'userGift'
  | 'changeName'
  | 'changeAppearance'
  | 'changeBackground';

type UseInventoryModalsParams = {
  data?: IstoreItem | any; // 아이템 정보
  currentUid?: string | null;
  photocardData?: IPhotoCard;
  ownerID?: string;
  amount?: number;
};

export default function useInventoryModals({ data, photocardData, ownerID, currentUid, amount }: UseInventoryModalsParams) {
  const [openBettingModal, setOpenBettingModal] = useState(false);
  const [openQuestCreateModal, setOpenQuestCreateModal] = useState(false);
  const [openUserGiftModal, setOpenUserGiftModal] = useState(false);
  // 통합 펫 변경 모달: 열릴 경우 옵션 값으로 구분
  const [openChangePet, setOpenChangePet] = useState<false | 'appearance' | 'name' | 'background'>(false);
  const openers = useMemo(
    () => ({
      openBettingDemo: () => setOpenBettingModal(true),
      openQuestCreate: () => setOpenQuestCreateModal(true),
      openUserGift: () => setOpenUserGiftModal(true),
      openChangeName: () => setOpenChangePet('name'),
      openChangeAppearance: () => setOpenChangePet('appearance'),
      openChangeBackground: () => setOpenChangePet('background'),
    }),
    [setOpenBettingModal, setOpenUserGiftModal, setOpenChangePet],
  );


  const renderModalPortal = () => {
    return (
      <>
        {openBettingModal && (
          <UseBettingItemModal
            open={openBettingModal}
            photocardData={photocardData}
            targetItemData={data}
            onClose={() => setOpenBettingModal(false)}
          />
        )}

        {openQuestCreateModal && (
          <UseQuestCreateItemModal
            open={openQuestCreateModal}
            photocardData={photocardData}
            targetItemData={data}
            onClose={() => setOpenQuestCreateModal(false)}
          />
        )}

        {openUserGiftModal && data && (
          <MakeItemModal
            targetItemData={data}
            photocardData={photocardData}
            close={() => setOpenUserGiftModal(false)}
          />
        )}

        {openChangePet && (
          <ChangePetModal
            open
            onClose={() => setOpenChangePet(false)}
            photocardData={photocardData}
            ownerID={ownerID || ''}
            targetItemData={data}
            options={openChangePet}
          />
        )}
      </>
    );
  };

  return { renderModalPortal, openers } as const;
}
